import { useTranslation } from '@/app/i18n/client'
import { Contact } from '@/app/types/ContactType'
import Image from 'next/image'
interface MemberContactCardProps {
  member: Contact
}

const MemberContactCard = ({ member }: MemberContactCardProps) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="shadow-[0_0_6px_0_rgba(0,0,0,0.1)] h-auto grid grid-cols-4 pt-4 pb-2 px-5 rounded-[3px] gap-x-5 mobile:p-[10px]">
        {/* Image */}
        <div className="col-span-1">
          <div className="w-[85px] h-[114px] overflow-hidden rounded-[5px]">
            {member?.profile ? (
              <Image
                loading="lazy"
                width={100}
                height={100}
                src={member?.profile}
                alt="profile_image"
                className="w-full h-full object-cover"
              />
            ) : (
              <Image
                loading="lazy"
                width={100}
                height={100}
                src="/assets/Icons/noImage/noImage2.svg"
                alt="profile_image"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>
        {/* Card Content */}
        <div className="col-span-3 flex flex-col gap-4 mobile:ml-[15px]">
          {/* Name & Function */}
          <div className="flex flex-col">
            <h2 className="w-full text-base font-ns_semibold whitespace-nowrap overflow-hidden text-ellipsis">
              {`${member?.title ?? ''} ${member?.first_name ?? ''} ${member?.last_name ?? ''}`}
            </h2>
            <p className="text-sm text-grey_forty">
              {member?.department?.name ?? ''}{' '}
              {member?.position
                ? `${member?.department?.name ? '-' : ''} ${member.position}`
                : ''}
            </p>
          </div>

          {/* Contact Details */}
          <div className="grid grid-cols-1 gap-y-2 text-sm">
            {/* Speaks */}
            <div className="flex items-start gap-1">
              <Image
                loading="lazy"
                width={12}
                height={12}
                src="/assets/Icons/languageIcon.svg"
                className="mr-1 mt-1"
                alt=""
              />
              <h4>{t('Speaks')}:</h4>
              <div className="flex gap-1 flex-wrap ml-0">
                {member?.languages?.length > 0
                  ? member?.languages?.map((language, index) => (
                      <div key={index} className="flex items-center">
                        <div>{language?.name ?? ''}</div>
                        {member?.languages?.length - 1 !== index && (
                          <span>, </span>
                        )}
                      </div>
                    ))
                  : t('NA')}
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-1">
              <Image
                loading="lazy"
                width={12}
                height={12}
                src="/assets/Icons/phoneIcon.svg"
                alt=""
                style={{ paddingTop: '2px' }}
                className="pt-[2px] mr-1"
              />
              <h4>{t('Phone')}:</h4>
              {/* Phone Numbers */}
              <div className="flex gap-1 flex-wrap ml-0">
                {member?.phone_access
                  ? member?.phones?.length > 0
                    ? member?.phones
                        .map(
                          (item) =>
                            `${item?.code?.dial_code ? `${item.code.dial_code} - ` : ''}${item?.contact ?? ''}`
                        )
                        .join(', ')
                    : t('Contact not available')
                  : '*************'}
              </div>
            </div>

            {/* Mobile */}
            <div className="flex items-start gap-1">
              <Image
                loading="lazy"
                width={12}
                height={12}
                src="/assets/Icons/mobileIcon.svg"
                alt=""
                className="h-4 mr-1 mt-[2px]"
              />
              <h4>{t('Mobile')}:</h4>
              {/* Mobile Numbers */}
              <div className="flex gap-1 flex-wrap ml-0">
                {member?.mobile_access
                  ? member?.mobiles?.length > 0
                    ? member?.mobiles
                        .map(
                          (item) =>
                            `${item?.code?.dial_code ?? ''} - ${item?.contact ?? ''}`
                        )
                        .join(', ')
                    : t('Contact not available')
                  : '*********'}
              </div>
            </div>

            {/* E-mail */}
            <div className="flex items-start gap-1">
              <Image
                loading="lazy"
                width={12}
                height={12}
                src="/assets/Icons/emailIcon.svg"
                className="mr-1 mt-[6px]"
                alt=""
              />
              <h4 className="text-nowrap">{t('E-mail')}:</h4>
              <div className="flex gap-1 flex-wrap ml-0">
                {member?.email_list?.length
                  ? member?.email_list.map((item) => (
                      <p
                        key={item}
                        className=" text-nowrap max-w-[250px] overflow-hidden truncate"
                        title={item}
                      >
                        {item}
                      </p>
                    ))
                  : t('Email not available')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MemberContactCard
